export const PUBLIC_GUEST_MODE = import.meta.env.VITE_PUBLIC_DEMO !== 'false';
export const GUEST_DATA_USER_ID = 'guest';
export const GUEST_PROFILE_KEY = 'world-traveler-guest-profile';